var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "fas fa-sign-in-alt" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("welcome_banner")) + "\n\t")
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              ref: "title",
              attrs: {
                "float-label": _vm.$t("title"),
                error: _vm.$v.title.$error
              },
              on: { input: _vm.$v.title.$touch },
              model: {
                value: _vm.title,
                callback: function($$v) {
                  _vm.title = $$v
                },
                expression: "title"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-xs-12 col-sm-12 " }, [
          _c("div", { staticClass: "row gutter-sm flex" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("p", { staticClass: "caption" }, [
                  _vm._v(_vm._s(_vm.$t("desktop_banner")))
                ]),
                _c("uploader", {
                  attrs: {
                    content_type: "images",
                    multiple: false,
                    cropper: true,
                    aspect_ratio: 1200 / 457,
                    aspect_ratio_string: "1200/457"
                  },
                  on: { fileUploaded: _vm.imageDesktopUploaded }
                }),
                _vm.image_desktop
                  ? _c(
                      "p",
                      { ref: "image_desktop", staticClass: "q-mt-md file-url" },
                      [
                        _c("q-icon", {
                          attrs: { name: "fas fa-check", color: "positive" }
                        }),
                        _c(
                          "a",
                          {
                            attrs: { href: _vm.image_desktop, target: "_blank" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.$truncateLink(_vm.image_desktop))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
              _c(
                "p",
                { staticClass: "caption" },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t("alt_image")) +
                      "\n\t\t\t\t\t\t"
                  ),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-ml-sm q-pb-sm",
                      attrs: {
                        name: "far fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("alt_image_information_helper")) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex justify-between" },
                [
                  _vm._l(_vm.languages, function(lang) {
                    return [
                      lang.code === "pt-br"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_br_desktop",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name)
                                },
                                model: {
                                  value: _vm.language_br_desktop,
                                  callback: function($$v) {
                                    _vm.language_br_desktop = $$v
                                  },
                                  expression: "language_br_desktop"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "en-us"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_us_desktop",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name)
                                },
                                model: {
                                  value: _vm.language_us_desktop,
                                  callback: function($$v) {
                                    _vm.language_us_desktop = $$v
                                  },
                                  expression: "language_us_desktop"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "es-es"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_es_desktop",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name)
                                },
                                model: {
                                  value: _vm.language_es_desktop,
                                  callback: function($$v) {
                                    _vm.language_es_desktop = $$v
                                  },
                                  expression: "language_es_desktop"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "fr-fr"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_fr_desktop",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name)
                                },
                                model: {
                                  value: _vm.language_fr_desktop,
                                  callback: function($$v) {
                                    _vm.language_fr_desktop = $$v
                                  },
                                  expression: "language_fr_desktop"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 " },
          [
            _c("div", { staticClass: "row gutter-sm flex" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-6" },
                [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("mobile_banner")))
                  ]),
                  _c("uploader", {
                    attrs: {
                      content_type: "images",
                      multiple: false,
                      cropper: true,
                      aspect_ratio: 500 / 485,
                      aspect_ratio_string: "500/485"
                    },
                    on: { fileUploaded: _vm.imageMobileUploaded }
                  }),
                  _vm.image_mobile
                    ? _c(
                        "p",
                        {
                          ref: "image_mobile",
                          staticClass: "q-mt-md file-url"
                        },
                        [
                          _c("q-icon", {
                            attrs: { name: "fas fa-check", color: "positive" }
                          }),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.image_mobile,
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$truncateLink(_vm.image_mobile))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                _c(
                  "p",
                  { staticClass: "caption" },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("alt_image")) +
                        "\n\t\t\t\t\t\t"
                    ),
                    _c(
                      "q-icon",
                      {
                        staticClass: "q-ml-sm q-pb-sm",
                        attrs: {
                          name: "far fa-question-circle",
                          size: "1.5rem",
                          color: "grey"
                        }
                      },
                      [
                        _c(
                          "q-tooltip",
                          {
                            staticClass: "custom-tooltip",
                            attrs: { anchor: "top left", self: "bottom right" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("alt_image_information_helper")) +
                                "\n\t\t\t\t\t\t\t"
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex justify-between" },
                  [
                    _vm._l(_vm.languages, function(lang) {
                      return [
                        lang.code === "pt-br"
                          ? _c(
                              "q-field",
                              { key: lang.id, attrs: { count: 170 } },
                              [
                                _c("q-input", {
                                  ref: "language_br_mobile",
                                  refInFor: true,
                                  attrs: {
                                    "float-label": _vm.$t("" + lang.name)
                                  },
                                  model: {
                                    value: _vm.language_br_mobile,
                                    callback: function($$v) {
                                      _vm.language_br_mobile = $$v
                                    },
                                    expression: "language_br_mobile"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        lang.code === "en-us"
                          ? _c(
                              "q-field",
                              { key: lang.id, attrs: { count: 170 } },
                              [
                                _c("q-input", {
                                  ref: "language_us_mobile",
                                  refInFor: true,
                                  attrs: {
                                    "float-label": _vm.$t("" + lang.name)
                                  },
                                  model: {
                                    value: _vm.language_us_mobile,
                                    callback: function($$v) {
                                      _vm.language_us_mobile = $$v
                                    },
                                    expression: "language_us_mobile"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        lang.code === "es-es"
                          ? _c(
                              "q-field",
                              { key: lang.id, attrs: { count: 170 } },
                              [
                                _c("q-input", {
                                  ref: "language_es_mobile",
                                  refInFor: true,
                                  attrs: {
                                    "float-label": _vm.$t("" + lang.name)
                                  },
                                  model: {
                                    value: _vm.language_es_mobile,
                                    callback: function($$v) {
                                      _vm.language_es_mobile = $$v
                                    },
                                    expression: "language_es_mobile"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        lang.code === "fr-fr"
                          ? _c(
                              "q-field",
                              { key: lang.id, attrs: { count: 170 } },
                              [
                                _c("q-input", {
                                  ref: "language_fr_mobile",
                                  refInFor: true,
                                  attrs: {
                                    "float-label": _vm.$t("" + lang.name)
                                  },
                                  model: {
                                    value: _vm.language_fr_mobile,
                                    callback: function($$v) {
                                      _vm.language_fr_mobile = $$v
                                    },
                                    expression: "language_fr_mobile"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ]),
              _c("div", { staticClass: "col-xs-12 col-sm-12" })
            ]),
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("content")))
            ]),
            _c(
              "q-editor",
              {
                attrs: {
                  toolbar: [
                    ["bold", "italic", "strike", "underline"],
                    ["left", "center", "right", "justify"],
                    ["link", "upload"],
                    [
                      {
                        label: null,
                        icon: "fas fa-font",
                        fixedLabel: true,
                        fixedIcon: true,
                        list: "no-icons",
                        options: [
                          "p",
                          "h1",
                          "h2",
                          "h3",
                          "h4",
                          "h5",
                          "h6",
                          "code"
                        ]
                      },
                      {
                        label: null,
                        icon: "fas fa-text-height",
                        fixedLabel: true,
                        fixedIcon: true,
                        list: "no-icons",
                        options: [
                          "size-1",
                          "size-2",
                          "size-3",
                          "size-4",
                          "size-5",
                          "size-6",
                          "size-7"
                        ]
                      },
                      "removeFormat"
                    ],
                    ["quote", "unordered", "ordered"],
                    ["custom_btn"]
                  ],
                  definitions: {
                    bold: { label: null, icon: "fas fa-bold" },
                    italic: { label: null, icon: "fas fa-italic" },
                    strike: { label: null, icon: "fas fa-strikethrough" },
                    underline: { label: null, icon: "fas fa-underline" },
                    left: { label: null, icon: "fas fa-align-left" },
                    center: { label: null, icon: "fas fa-align-center" },
                    right: { label: null, icon: "fas fa-align-right" },
                    justify: { label: null, icon: "fas fa-align-justify" },
                    link: { label: null, icon: "fas fa-link" },
                    upload: {
                      tip: null,
                      icon: "fas fa-file-image",
                      handler: _vm.insertImg
                    },
                    removeFormat: { label: null, icon: "fas fa-eraser" },
                    quote: { label: null, icon: "fas fa-quote-right" },
                    unordered: { label: null, icon: "fas fa-list-ul" },
                    ordered: { label: null, icon: "fas fa-list-ol" }
                  }
                },
                model: {
                  value: _vm.content,
                  callback: function($$v) {
                    _vm.content = $$v
                  },
                  expression: "content"
                }
              },
              [
                _c("q-btn", {
                  attrs: {
                    slot: "custom_btn",
                    dense: "",
                    flat: "",
                    color: "black",
                    icon: "fas fa-code",
                    label: "HTML"
                  },
                  on: {
                    click: function($event) {
                      _vm.show_html = true
                    }
                  },
                  slot: "custom_btn"
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              attrs: {
                options: _vm.bannerTypes,
                "float-label": _vm.$t("banner_type")
              },
              model: {
                value: _vm.banner_welcome_type,
                callback: function($$v) {
                  _vm.banner_welcome_type = $$v
                },
                expression: "banner_welcome_type"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              ref: "start_date",
              attrs: {
                type: "date",
                "float-label": _vm.$t("start_date"),
                format: "DD/MM/YYYY",
                error: _vm.$v.start_date.$error
              },
              on: { input: _vm.$v.start_date.$touch },
              model: {
                value: _vm.start_date,
                callback: function($$v) {
                  _vm.start_date = $$v
                },
                expression: "start_date"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              ref: "end_date",
              attrs: {
                type: "date",
                "float-label": _vm.$t("end_date"),
                format: "DD/MM/YYYY",
                error: _vm.$v.end_date.$error
              },
              on: { input: _vm.$v.end_date.$touch },
              model: {
                value: _vm.end_date,
                callback: function($$v) {
                  _vm.end_date = $$v
                },
                expression: "end_date"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "permissions",
              icon: "fas fa-clipboard-check",
              label: _vm.$t("permissions")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "permissions" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("areas")))
                    ]),
                    _c("q-checkbox", {
                      staticClass: "q-mb-sm",
                      attrs: { val: true, label: _vm.$t("select_all_areas") },
                      on: {
                        input: function($event) {
                          return _vm.checkAllAreas()
                        }
                      },
                      model: {
                        value: _vm.all_areas,
                        callback: function($$v) {
                          _vm.all_areas = $$v
                        },
                        expression: "all_areas"
                      }
                    }),
                    _c("select-multiple", {
                      attrs: {
                        filters: _vm.area,
                        options: _vm.areas,
                        error: _vm.$v.area.$error,
                        input: _vm.$v.area.$touch
                      },
                      on: {
                        on_value: function($event) {
                          _vm.area = $event
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("profiles")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-checkbox", {
                            attrs: { val: true, label: _vm.$t("all") },
                            on: {
                              input: function($event) {
                                return _vm.checkAll()
                              }
                            },
                            model: {
                              value: _vm.all_profiles,
                              callback: function($$v) {
                                _vm.all_profiles = $$v
                              },
                              expression: "all_profiles"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.profiles, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            ref: "profile",
                            refInFor: true,
                            staticClass: "col-xs-12 col-sm-4",
                            class: _vm.getErrorClass(_vm.$v.profile.$error)
                          },
                          [
                            _c("q-checkbox", {
                              attrs: {
                                "keep-color": "",
                                val: item.value,
                                label: item.label,
                                color: _vm.getErrorColor(_vm.$v.profile.$error)
                              },
                              on: { input: _vm.$v.profile.$touch },
                              model: {
                                value: _vm.profile,
                                callback: function($$v) {
                                  _vm.profile = $$v
                                },
                                expression: "profile"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-select", {
                            ref: "user_group",
                            attrs: {
                              options: _vm.user_groups,
                              "float-label": _vm.$t("groups"),
                              error: _vm.$v.user_group.$error,
                              multiple: "",
                              chips: ""
                            },
                            on: { input: _vm.$v.user_group.$touch },
                            model: {
                              value: _vm.user_group,
                              callback: function($$v) {
                                _vm.user_group = $$v
                              },
                              expression: "user_group"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm q-my-sm" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("status")))
            ]),
            _c("q-btn-toggle", {
              attrs: {
                "toggle-color": _vm.getColorStatus,
                options: _vm.statuses
              },
              model: {
                value: _vm.status,
                callback: function($$v) {
                  _vm.status = $$v
                },
                expression: "status"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "banners_welcome" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_html,
            callback: function($$v) {
              _vm.show_html = $$v
            },
            expression: "show_html"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_html = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [_vm._v("\n\t\t\t\t\tHTML\n\t\t\t\t")])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "textarea",
                          rows: "10",
                          "float-label": "HTML"
                        },
                        model: {
                          value: _vm.content,
                          callback: function($$v) {
                            _vm.content = $$v
                          },
                          expression: "content"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("close"),
                            icon: "fas fa-ban"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_html = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }